import ApiCall from "utils/ApiCall"

export interface IOperationStatus {
  id: string;
  alias: string;
  checkIn: boolean;
  checkOut: boolean;
  keyPickUp:boolean
}

export const getAllOperationStatus =async()=>{
  const route = `${process.env.REACT_APP_API}/configurations/operationstatus`;
  return await ApiCall.get(route);
}

export const updateOperationStatus = async (body: IOperationStatus) => {
  const route = `${process.env.REACT_APP_API}/configurations/operationstatus`;
  return await ApiCall.put(route, body);
};